
import { cn } from '@/lib/utils';
import { Icon } from './icon';

/** Gold rating stars. With no reviews yet, shows a neutral "new" label
    instead of a fabricated score (e.g. never "5.0 (211)" with 0 reviews). */
export function Rating({
  value,
  valueText,
  count,
  countText,
  newLabel = 'Novo',
  className,
}: {
  value: number;
  /** Localized replacement for the score itself ("4,5"); without it the raw
   *  `toFixed(1)` is used, which prints a dot in every language. */
  valueText?: string;
  count?: number;
  /** Optional localized replacement for the bare count, e.g. "312 avaliações". */
  countText?: string;
  newLabel?: string;
  className?: string;
}) {
  if (!count || count <= 0) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 text-[0.8125rem] text-muted-foreground',
          className,
        )}
      >
        <Icon name="star" size={14} className="text-neutral-300" />
        {newLabel}
      </span>
    );
  }
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <Icon name="star" size={14} className="text-warning" />
      <span className="text-[0.8125rem] font-semibold text-foreground">{valueText ?? value.toFixed(1)}</span>
      <span className="text-[0.8125rem] text-muted-foreground">({countText ?? count})</span>
    </span>
  );
}
